import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
// import "element-ui/lib/stheme-chalk/index.css";
import "./assets/css/wd-theme/theme/index.css";

//引入中英文切换
import i18n from "./assets/js/index";

//引入时间格式管理
import moment from "moment"; //导入文件
Vue.prototype.$moment = moment; //赋值使用

Vue.use(ElementUI);

//富文本编辑器
import quillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(quillEditor);

// 打印工具
import Print from "./assets/js/print";
Vue.use(Print);

// 工具库
import util from "./assets/js/utils";
Vue.prototype.$util = util;

// import './assets/font/iconfont.js'
// import './assets/font/iconfont.css'
// 全局指令
/**
 * 1. v-enter-number 输入正整数 or  v-enter-number.float="2" (保留两位小数,最多保留三位)
 * 2. v-loadmore="function"  表格滚动加载 @parmas:function  自定义逻辑(参考：sales_volume.vue)
 */
import directive from "./directive/";
Vue.use(directive);

// 全局过滤器
/**
 * 1. {{时间戳 | dateFormat}} or {{时间戳 | dateFormat('YYYY年MM月DD日')}}
 */
import filters from "./filters/";
Vue.use(filters);

Vue.config.productionTip = false;

/* eslint-disable no-new */
let app = new Vue({
    el: "#app",
    router,
    store,
    i18n,
    components: {
        App
    },
    render: h => h(App),
    data: {
        eventBus: new Vue()
    }
});
//拖拽
import VueDND from 'awe-dnd'
Vue.use(VueDND)
//全局修改提示时间
Vue.prototype.$message = function (msg) {
    ElementUI.Message({ ...msg, duration: 2000, offset: 50 })
}

Vue.prototype.$message.error = function (msg) {
    return ElementUI.Message.error({
        message: msg,
        duration: 3000,
        offset: 50
    })
}

Vue.prototype.$message.success = function (msg) {
    return ElementUI.Message.success({
        message: msg,
        duration: 2000,
        offset: 50
    })
}
Vue.prototype.$message.warning = function (msg) {
    return ElementUI.Message.warning({
        message: msg,
        duration: 3000,
        offset: 50
    })
}
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?d1f89327b4e432d1f36cbb5e58ddfa77";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();